/** @jsx jsx */
import { jsx, Heading, Card, Box } from 'theme-ui'
import CarouselSlider from '../shared/Carousel/CarouselSlider'
import Link from '../shared/Typography/Link/Link'
import Img from 'gatsby-image'
import React, { useState } from 'react'
import { useWindowSize } from '../../hooks/useWindowSize'

const CarouselItem = ({ item, ...props }) => {
  return (
    <Card {...props}>
      <Link to={props.clickable && `/${item.toSlug}`}>
        <Img objectFit="cover" fluid={item.image.fluid} />
        <Heading
          as="h4"
          sx={{
            textTransform: 'uppercase',
            mt: '15px',
          }}
        >
          {item.title}
        </Heading>
      </Link>
    </Card>
  )
}
const CarouselContainer = props => {
  const [clickable, setClickable] = useState(true)
  const { mobile } = useWindowSize()

  return (
    <Box sx={{ maxWidth: '100%' }}>
      {props.showTitle && props.carouselItem.length > 1 && (
        <Heading
          as={mobile ? 'h5' : 'h4'}
          variant="semiBold"
          sx={{
            mb: 20,
            ml: ['1em', null, '8rem'],
            textAlign: 'left',
          }}
        >
          {props.title}
        </Heading>
      )}
      <CarouselSlider
        onStartScroll={() => setClickable(false)}
        onClick={() => setClickable(true)}
        onEndScroll={() => setClickable(true)}
      >
        {props.carouselItem.map((item, k) => (
          <>
            <CarouselItem
              sx={{
                minWidth: ['75vw', null, '33vw'],
                paddingRight: props.carouselItem.length - 1 ? 0 : 20,
                ml: k === 0 && ['1em', null, '8em'],
                mr:
                  k === props.carouselItem.length - 1
                    ? ['-0.5em', null, '6.5em']
                    : 20,
              }}
              key={k}
              item={item}
              clickable={clickable}
            />
            {k === props.carouselItem.length - 1 && <Heading>&nbsp;</Heading>}
          </>
        ))}
      </CarouselSlider>
    </Box>
  )
}

export default CarouselContainer
